/** @graphql cc **/
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql';

import {
	SitePermissionType,
	type FetchNativeCollabConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes as Person,
	type FetchNativeCollabConfluenceUsersQuery as UsersQuery$data,
	type FetchNativeCollabConfluenceUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchNativeCollabConfluenceUsersQuery';

export const fetchNativeCollabConfluenceUsers = (accountIds: string[]) => {
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchNativeCollabConfluenceUsersQuery($accountIds: [String]) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							profilePicture {
								isDefault
								path(type: RELATIVE)
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							displayName
							permissionType
						}
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user): user is Person => (user as any)?.accountId)
					.map((user) => ({
						avatar: user.profilePicture?.path ?? '',
						email: '',
						isGuest: user.permissionType === SitePermissionType.EXTERNAL ?? undefined,
						name: user.displayName ?? '',
						userId: (user as any).accountId,
					})) ?? []
			);
		});
};
